import { Box } from '@mui/material'
import { Tabs } from '@ui/navigation'

interface Props {
  isShowingFile: boolean
  onShowFileChange: (isShowingFile: boolean) => void
}

// Properties of a markdown page with an attached file: the page itself
// ("Markdown", previewed as a whole) or the attached file ("Datei", previewed
// with its crop margins or editable)
const TemplateFileTabs = ({ isShowingFile, onShowFileChange }: Props) => (
  <Box>
    <Tabs
      items={[
        { id: 'template', label: 'Markdown' },
        { id: 'file', label: 'Datei' },
      ]}
      value={isShowingFile ? 'file' : 'template'}
      onChange={id => onShowFileChange(id === 'file')}
      size="sm"
    />
  </Box>
)

export default TemplateFileTabs
